import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts';
import { AccessDenied } from './AccessDenied';

export interface RoleBasedProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles: ('superuser' | 'staff' | 'moderator')[];
  requireAll?: boolean; // true: tüm roller gerekli, false: herhangi biri yeterli
}

export const RoleBasedProtectedRoute = ({
  children,
  allowedRoles,
  requireAll = false,
}: RoleBasedProtectedRouteProps) => {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div className="p-4 sm:p-6 lg:p-8 bg-gradient-to-br from-gray-50 to-white min-h-screen flex items-center justify-center">
        <div className="text-gray-600">Yükleniyor...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has required roles
  const hasAccess = requireAll
    ? allowedRoles.every((role) => {
      if (role === 'superuser') return user.isSuperuser;
      if (role === 'staff') return user.isStaff;
      if (role === 'moderator') return user.isModerator;
      return false;
    })
    : allowedRoles.some((role) => {
      if (role === 'superuser') return user.isSuperuser;
      if (role === 'staff') return user.isStaff;
      if (role === 'moderator') return user.isModerator;
      return false;
    });

  if (!hasAccess) {
    return (
      <AccessDenied
        message="Bu sayfaya erişmek için gerekli yetkilere sahip değilsiniz."
        requiredRoles={allowedRoles}
      />
    );
  }

  return <>{children}</>;
};

